"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7415],{

/***/ 87415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOneClickBridge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37091);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27234);
/* harmony import */ var _libs_oneclick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46837);
/* harmony import */ var _useAccount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98786);









function useOneClickBridge(serviceId) {
    var ref = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), form = ref.form, changeFormField = ref.changeFormField;
    var address = (0,_useAccount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().address;
    var bridge = _libs_oneclick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP[serviceId];
    var ZKSyncBridge = _libs_oneclick__WEBPACK_IMPORTED_MODULE_3__/* ["default"].zkSync */ .ZP.zkSync;
    var ref1 = (0,_stores__WEBPACK_IMPORTED_MODULE_2__/* .useTypedSelector */ .ix)(function(state) {
        return state.bridge;
    }), depositing = ref1.depositing, depositSuccess = ref1.depositSuccess;
    var zkSyncDeposit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var depositInfo, paymentInfo, transaction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    depositInfo = form === null || form === void 0 ? void 0 : form.zksync;
                    return [
                        4,
                        ZKSyncBridge.getPaymentInfo(address, {
                            chainId: parseInt(depositInfo.chain),
                            tokenAmount: depositInfo.depositCost
                        })
                    ];
                case 1:
                    paymentInfo = _state.sent();
                    console.log("start zksync deposit", paymentInfo);
                    _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        ,
                        4,
                        5
                    ]);
                    return [
                        4,
                        ZKSyncBridge.deposit(paymentInfo)
                    ];
                case 3:
                    transaction = _state.sent();
                    _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
                    return [
                        2,
                        transaction
                    ];
                case 4:
                    _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        address,
        form,
        serviceId
    ]);
    var recover = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(transaction) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            5,
                            6
                        ]);
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
                        return [
                            4,
                            bridge.oneClickBridgeConfirm(transaction)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            bridge.waitUntilMintSuccess(transaction)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                setTimeout(resolve, 3000);
                            })
                        ];
                    case 4:
                        _state.sent();
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.vc.setMintSuccess */ .Nw.vc.setMintSuccess(true));
                        return [
                            2,
                            transaction
                        ];
                    case 5:
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(transaction) {
            return _ref.apply(this, arguments);
        };
    }(), [
        address,
        form,
        serviceId
    ]);
    var karatDeposit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(data) {
            var escrowDepositInfo, ref, paymentInfo, transaction;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        escrowDepositInfo = form === null || form === void 0 ? void 0 : form.karat;
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            8
                        ]);
                        return [
                            4,
                            bridge.getPaymentInfo(address, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                walletAddress: address,
                                token: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token), {
                                    address: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref = escrowDepositInfo.token) === null || ref === void 0 ? void 0 : ref.tokenAddress
                                })
                            }, data))
                        ];
                    case 2:
                        paymentInfo = _state.sent();
                        console.log("start karat deposit", paymentInfo);
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.vc.setMintSuccess */ .Nw.vc.setMintSuccess(false));
                        return [
                            4,
                            bridge.deposit(paymentInfo)
                        ];
                    case 3:
                        transaction = _state.sent();
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
                        return [
                            4,
                            bridge.oneClickBridgeConfirm(transaction)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            bridge.waitUntilMintSuccess(transaction)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                setTimeout(resolve, 3000);
                            })
                        ];
                    case 6:
                        _state.sent();
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.vc.setMintSuccess */ .Nw.vc.setMintSuccess(true));
                        return [
                            2,
                            transaction
                        ];
                    case 7:
                        _stores__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_2__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        address,
        form,
        serviceId
    ]);
    return {
        depositing: depositing,
        depositSuccess: depositSuccess,
        karatDeposit: karatDeposit,
        zkSyncDeposit: zkSyncDeposit,
        recover: recover
    };
}


/***/ }),

/***/ 46837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W4": function() { return /* binding */ OneClickBridge; },
/* harmony export */   "q_": function() { return /* binding */ BridgeTransactionStatus; }
/* harmony export */ });
/* unused harmony exports Service, Bridge, ZKSyncBridge */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82337);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var wagmi_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17276);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61744);
/* harmony import */ var _chain_info_contracts_Escrow_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95902);
/* harmony import */ var store2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11860);
/* harmony import */ var store2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(store2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6293);
/* harmony import */ var zksync_web3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31041);
/* harmony import */ var zksync_web3__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(zksync_web3__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mitt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59391);
/* harmony import */ var _services_ethers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10644);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58903);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22852);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_validate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68974);



















var STORE_TRANSACTIONS = "bridge-transactions";
var BridgeTransactionStatus;
(function(BridgeTransactionStatus) {
    BridgeTransactionStatus[BridgeTransactionStatus["PENDING"] = 0] = "PENDING";
    BridgeTransactionStatus[BridgeTransactionStatus["DEPOSIT_SUCCESS"] = 1] = "DEPOSIT_SUCCESS";
    BridgeTransactionStatus[BridgeTransactionStatus["DEPOSIT_FAIL"] = 2] = "DEPOSIT_FAIL";
    BridgeTransactionStatus[BridgeTransactionStatus["MINTING"] = 3] = "MINTING";
    BridgeTransactionStatus[BridgeTransactionStatus["MINT_SUCCESS"] = 4] = "MINT_SUCCESS";
    BridgeTransactionStatus[BridgeTransactionStatus["MINT_FAIL"] = 5] = "MINT_FAIL";
})(BridgeTransactionStatus || (BridgeTransactionStatus = {}));
function isNativeToken(address) {
    return address === "0x0000000000000000000000000000000000000000" || address === "0x0000000000000000000000000000000000001010";
}
var Service = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function Service(id) {
        _class_call_check(this, Service);
        this.id = id;
    }
    var _proto = Service.prototype;
    _proto.getPaymentInfo = function getPaymentInfo(data) {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                throw new Error("Not implemented");
            });
        })();
    };
    return Service;
}()));
var Bridge = /*#__PURE__*/ function() {
    "use strict";
    function Bridge(type, serviceId) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, Bridge);
        this.type = type;
        this.serviceId = serviceId;
        this.emitter = (0,mitt__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    }
    var _proto = Bridge.prototype;
    _proto.newTransaction = function newTransaction(transactionHash, paymentInfo) {
        var transaction = {
            transactionHash: transactionHash,
            paymentInfo: paymentInfo,
            createAt: Date.now(),
            status: BridgeTransactionStatus.PENDING,
            bridgeType: this.type
        };
        store2__WEBPACK_IMPORTED_MODULE_1___default().transact(STORE_TRANSACTIONS, function(trans) {
            return (trans || []).concat(transaction);
        });
        this.emitter.emit("newTransaction", transaction);
        mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default().track("bridge_new_transaction", {
            serviceId: this.serviceId,
            transaction: transaction
        });
    };
    _proto.updateTransactionStatus = function updateTransactionStatus(transactionHash, status) {
        store2__WEBPACK_IMPORTED_MODULE_1___default().transact(STORE_TRANSACTIONS, function(trans) {
            var transaction = (trans || []).find(function(transaction) {
                return transaction.transactionHash === transactionHash;
            });
            if (transaction) {
                transaction.status = status;
            }
        });
        var transaction = this.getTransaction(transactionHash);
        if (transaction) {
            this.emitter.emit("transactionStatusChange", transaction);
            mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default().track("bridge_transaction_update", {
                serviceId: this.serviceId,
                transaction: transaction
            });
        }
        console.log("transactionStatusChange", transaction);
    };
    _proto.getTransaction = function getTransaction(transactionHash) {
        var transactions = store2__WEBPACK_IMPORTED_MODULE_1___default().get(STORE_TRANSACTIONS) || [];
        return transactions.find(function(trans) {
            return trans.transactionHash === transactionHash;
        });
    };
    _proto.getTransactions = function getTransactions(status) {
        var _this = this;
        var transactions = store2__WEBPACK_IMPORTED_MODULE_1___default().get(STORE_TRANSACTIONS) || [];
        return transactions.filter(function(trans) {
            if (trans.bridgeType !== _this.type || trans.paymentInfo._serviceId !== _this.serviceId) {
                return false;
            }
            if (typeof status !== "undefined") {
                return trans.status === status;
            }
            return true;
        });
    };
    _proto.getPaymentInfo = function getPaymentInfo(wallet, data) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                throw new Error("Not implemented");
            });
        })();
    };
    _proto.deposit = function deposit(paymentInfo) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                throw new Error("Not implemented");
            });
        })();
    };
    _proto.waitUntilMintSuccess = function waitUntilMintSuccess(transaction) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60000;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                throw new Error("Not implemented");
            });
        })();
    };
    return Bridge;
}();
var ZKSyncBridge = /*#__PURE__*/ function(Bridge) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(ZKSyncBridge, Bridge);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ZKSyncBridge);
    function ZKSyncBridge() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ZKSyncBridge);
        return _super.call(this, "zkSync", "zksync");
    }
    var _proto = ZKSyncBridge.prototype;
    _proto.getPaymentInfo = function getPaymentInfo(wallet, data) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, data), {
                        _wallet: wallet,
                        _serviceId: _this.serviceId
                    })
                ];
            });
        })();
    };
    _proto.deposit = function deposit(paymentInfo) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var chain, zksyncProvider, walletClient, signer, depositHandle;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default().track("bridge_deposit", {
                            serviceId: _this.serviceId,
                            type: _this.type,
                            paymentInfo: paymentInfo
                        });
                        chain = (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .getNetwork */ .Hy)().chain;
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== paymentInfo.chainId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .switchNetwork */ .If)({
                                chainId: paymentInfo.chainId
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        zksyncProvider = new zksync_web3__WEBPACK_IMPORTED_MODULE_3__.Provider(paymentInfo.chainId === 1 ? "https://mainnet.era.zksync.io" : "https://testnet.era.zksync.dev");
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .getWalletClient */ .xz)({
                                chainId: paymentInfo.chainId
                            })
                        ];
                    case 3:
                        walletClient = _state.sent();
                        signer = zksync_web3__WEBPACK_IMPORTED_MODULE_3__.L1Signer.from((0,_services_ethers__WEBPACK_IMPORTED_MODULE_15__/* .walletClientToSigner */ .S)(walletClient), zksyncProvider);
                        return [
                            4,
                            signer.deposit({
                                token: zksync_web3__WEBPACK_IMPORTED_MODULE_3__.utils.ETH_ADDRESS,
                                amount: ethers__WEBPACK_IMPORTED_MODULE_16__.parseEther(paymentInfo.tokenAmount.toFixed(18))
                            })
                        ];
                    case 4:
                        depositHandle = _state.sent();
                        _this.newTransaction(depositHandle.hash, paymentInfo);
                        return [
                            4,
                            depositHandle.wait()
                        ];
                    case 5:
                        _state.sent();
                        _this.updateTransactionStatus(depositHandle.hash, BridgeTransactionStatus.DEPOSIT_SUCCESS);
                        return [
                            2,
                            _this.getTransaction(depositHandle.hash)
                        ];
                }
            });
        })();
    };
    return ZKSyncBridge;
}(Bridge);
var OneClickBridge = /*#__PURE__*/ function(Bridge) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(OneClickBridge, Bridge);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(OneClickBridge);
    function OneClickBridge(serviceId) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, OneClickBridge);
        return _super.call(this, "one-click", serviceId);
    }
    var _proto = OneClickBridge.prototype;
    _proto.getPaymentInfo = function getPaymentInfo(wallet, data) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].rpc */ .Z.rpc(_this.serviceId, data)
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, resp), {
                                _wallet: wallet,
                                _serviceId: _this.serviceId
                            })
                        ];
                }
            });
        })();
    };
    _proto.oneClickBridgeConfirm = function oneClickBridgeConfirm(transaction) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var paymentInfo;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (transaction.bridgeType !== "one-click") {
                            throw new Error("Transaction type is not one-click");
                        }
                        paymentInfo = transaction.paymentInfo;
                        return [
                            4,
                            _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].rpc */ .Z.rpc("network/oneclickBridgeConfirm", {
                                walletAddress: paymentInfo._wallet,
                                oneclickBridgeId: paymentInfo.oneclickBridgeId,
                                depositChainId: paymentInfo.token.chainId,
                                depositTransactionHash: transaction.transactionHash
                            })
                        ];
                    case 1:
                        _state.sent();
                        _this.updateTransactionStatus(transaction.transactionHash, BridgeTransactionStatus.MINTING);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getOneClickBridgeUnConfirmedTasks = function getOneClickBridgeUnConfirmedTasks(wallet) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].rpc */ .Z.rpc("network/getOneclickBridgeUnConfirmedTasks", {
                                walletAddress: wallet,
                                actionMethod: _this.serviceId
                            })
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            2,
                            resp
                        ];
                }
            });
        })();
    };
    _proto.waitUntilMintSuccess = function waitUntilMintSuccess(transaction) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60000;
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var endDate, that, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        endDate = Date.now() + timeout;
                        that = _this;
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                function checker() {
                                    return _checker.apply(this, arguments);
                                }
                                function _checker() {
                                    _checker = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                        var tasks, isExist, e;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (Date.now() > endDate) {
                                                        return [
                                                            2,
                                                            resolve(false)
                                                        ];
                                                    }
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4,
                                                        that.getOneClickBridgeUnConfirmedTasks(transaction.paymentInfo._wallet)
                                                    ];
                                                case 2:
                                                    tasks = _state.sent();
                                                    isExist = tasks.find(function(task) {
                                                        return task.transactionHash === transaction.transactionHash;
                                                    });
                                                    if (!isExist) {
                                                        that.updateTransactionStatus(transaction.transactionHash, BridgeTransactionStatus.MINT_SUCCESS);
                                                        return [
                                                            2,
                                                            resolve(true)
                                                        ];
                                                    }
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 3:
                                                    e = _state.sent();
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 4:
                                                    setTimeout(checker, 1000);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return _checker.apply(this, arguments);
                                }
                                checker();
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                }
            });
        })();
    };
    _proto.deposit = function deposit(paymentInfo) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var chain, isTokenNative, resp, e, resp1, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default().track("bridge_deposit", {
                            serviceId: _this.serviceId,
                            type: _this.type,
                            paymentInfo: paymentInfo
                        });
                        chain = (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .getNetwork */ .Hy)().chain;
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== paymentInfo.token.chainId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .switchNetwork */ .If)({
                                chainId: paymentInfo.token.chainId
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        isTokenNative = isNativeToken(paymentInfo.token.tokenAddress);
                        if (!!isTokenNative) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .writeContract */ .n9)({
                                address: paymentInfo.token.tokenAddress,
                                chainId: paymentInfo.token.chainId,
                                abi: wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .erc20ABI */ .em,
                                functionName: "approve",
                                args: [
                                    paymentInfo.escrowContractAddress,
                                    (0,viem__WEBPACK_IMPORTED_MODULE_17__/* .parseEther */ .f)(paymentInfo.tokenAmount.toFixed(18))
                                ]
                            })
                        ];
                    case 3:
                        resp = _state.sent();
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash,
                                confirmations: 2
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 6:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_5__/* .isSkipError */ .D0)(e)
                        ];
                    case 7:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            8
                        ];
                    case 8:
                        if (!isTokenNative) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .writeContract */ .n9)({
                                address: paymentInfo.escrowContractAddress,
                                chainId: paymentInfo.token.chainId,
                                abi: _chain_info_contracts_Escrow_json__WEBPACK_IMPORTED_MODULE_0__/* .abi */ .Mt,
                                functionName: "depositNativeToken",
                                value: (0,viem__WEBPACK_IMPORTED_MODULE_17__/* .parseEther */ .f)(paymentInfo.tokenAmount.toFixed(18))
                            })
                        ];
                    case 9:
                        resp1 = _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 10:
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .writeContract */ .n9)({
                                address: paymentInfo.escrowContractAddress,
                                chainId: paymentInfo.token.chainId,
                                abi: _chain_info_contracts_Escrow_json__WEBPACK_IMPORTED_MODULE_0__/* .abi */ .Mt,
                                functionName: "depositERC20",
                                args: [
                                    paymentInfo.token.tokenAddress,
                                    (0,viem__WEBPACK_IMPORTED_MODULE_18__/* .parseUnits */ .v)(String(paymentInfo.tokenAmount), 18)
                                ]
                            })
                        ];
                    case 11:
                        resp1 = _state.sent();
                        _state.label = 12;
                    case 12:
                        _this.newTransaction(resp1.hash, paymentInfo);
                        _state.label = 13;
                    case 13:
                        _state.trys.push([
                            13,
                            15,
                            ,
                            17
                        ]);
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .waitForTransaction */ .Mn)({
                                hash: resp1.hash,
                                confirmations: 2
                            })
                        ];
                    case 14:
                        _state.sent();
                        return [
                            3,
                            17
                        ];
                    case 15:
                        e1 = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_5__/* .isSkipError */ .D0)(e1)
                        ];
                    case 16:
                        if (!_state.sent()) {
                            throw e1;
                        }
                        return [
                            3,
                            17
                        ];
                    case 17:
                        _this.updateTransactionStatus(resp1.hash, BridgeTransactionStatus.DEPOSIT_SUCCESS);
                        return [
                            2,
                            _this.getTransaction(resp1.hash)
                        ];
                }
            });
        })();
    };
    return OneClickBridge;
}(Bridge);
var bridges = {
    registerVC: new OneClickBridge("vc/registerVC"),
    zkSync: new ZKSyncBridge(),
    revokeVC: new OneClickBridge("vc/removeVC")
};
/* harmony default export */ __webpack_exports__["ZP"] = (bridges);


/***/ })

}]);